import get from 'lodash/get';
import merge from 'lodash/merge';
import queryString from 'qs';
function setQueryStringValue(value, isSinglePage) {
  if (window) {
    var query = queryString.parse((get(window, 'location.search') || '').replace('?', '')) || {};
    merge(query, value);
    if (isSinglePage && get(window, 'history.pushState')) {
      window.history.pushState({}, '', "".concat(window.location.pathname, "?").concat(queryString.stringify(query)));
    } else if (window.location) {
      window.location.search = "?".concat(queryString.stringify(query));
    }
  }
}
export default setQueryStringValue;